import { useEffect, useState } from "react";
import { Menu, X, LogIn } from "lucide-react";
import { CONTACT, LOGO_WHITE } from "@/data";

const CLIENT_PORTAL_URL =
  "https://clienthub.getjobber.com/client_hubs/eb5c28a4-366e-41f5-80a5-6040435b1b6a/login/new?source=share_login";

const LINKS = [
  { label: "Work", href: "#gallery" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-navy/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-2 group">
          <img src={LOGO_WHITE} alt="The Mailbox Brothers LLC" className="h-11 md:h-12 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="font-primary uppercase text-sm tracking-wide text-ice/80 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={CLIENT_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-client-portal"
            className="font-primary uppercase text-sm tracking-wide text-ice/80 hover:text-gold transition-colors flex items-center gap-1.5"
          >
            <LogIn size={15} /> Client Portal
          </a>
          <a
            href="#quote"
            data-testid="header-quote-btn"
            className="font-primary uppercase text-sm tracking-wide bg-gold text-navy px-6 py-3 hover:shadow-[4px_4px_0px_#F4F7F6] transition-shadow"
          >
            Book Today
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-ice p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-navy border-t border-ice/10 px-5 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="font-primary uppercase text-ice text-xl">
              {l.label}
            </a>
          ))}
          <a
            href={CLIENT_PORTAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-client-portal"
            onClick={() => setOpen(false)}
            className="font-primary uppercase text-ice text-xl flex items-center gap-2"
          >
            <LogIn size={18} /> Client Portal
          </a>
          <a href={CONTACT.phoneHref} className="font-primary uppercase text-gold text-xl">Call {CONTACT.phone}</a>
        </div>
      )}
    </header>
  );
};
